import React from "react";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import Popup from "../common/Popup";

const SessionCompletedModal = ({ open, onClose }) => {
  const navigate = useNavigate();

  const handleGoToDashboard = () => {
    navigate("/");
    onClose();
  };

  const handleCreateReport = () => {
    navigate("/reports/");
    onClose();
  };

  const content = (
    <div className="py-4">
      <p className="mb-3">
        You have successfully completed your session. Your responses have been saved.
      </p>
      <p>
        You can now return to the dashboard or create a report based on your session responses.
      </p>
    </div>
  );

  const footer = [
    <Button 
      key="dashboard" 
      type="primary" 
      onClick={handleGoToDashboard}
      className="bg-primary hover:bg-primaryLight"
    >
      Go to Dashboard
    </Button>,
    <Button 
      key="report" 
      type="default"
      onClick={handleCreateReport}
      className="border-primary text-primary hover:bg-primaryLight hover:text-white hover:border-primaryLight"
    >
      Create Report
    </Button>,
  ];

  return (
    <Popup
      title="Session Completed! 🎉"
      open={open}
      onCancel={onClose}
      content={content}
      footer={footer}
    />
  );
};

export default SessionCompletedModal; 